import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {CmsComponentData} from '@spartacus/storefront';
import {
  CmsFlexComponentData
} from '../checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {IFrameMessageService} from '../services/iframe/iframe-message.service';
import {ContactFormIFrameData} from './contact-cta.component.model';
import {ComponentService} from '../services/component.service';
import {FetchTextsComponent} from '../shared/fetch-texts/fetch-texts.component';
import {Sap4MeHideHeaderService} from '../services/sap4me-hide-header.service';
import {CLOSE_EVENT} from '@dcp/configurator';

@Component({
  selector: 'dcp-contact-cta',
  templateUrl: './contact-cta.component.html',
})
export class ContactCtaComponent extends FetchTextsComponent implements OnInit, OnDestroy {

  componentTexts: ContactFormIFrameData;

  constructor(
    private iframeMessageService: IFrameMessageService,
    protected cmsData: CmsComponentData<CmsFlexComponentData>,
    protected componentService: ComponentService,
    protected cdr: ChangeDetectorRef,
    private sap4MeHideHeaderService: Sap4MeHideHeaderService,
  ) {
    super(cmsData, componentService, cdr);
  }

  ngOnDestroy(): void {
    this.sap4MeHideHeaderService.revertHiding();
  }

  ngOnInit(): void {
    this.fetchComponentData();
    this.sap4MeHideHeaderService.hideHeader();
  }

  /**
   * Close the iFrame on button click.
   */
  sendCloseEvent(): void {
    this.iframeMessageService.postMessage({eventId: CLOSE_EVENT});
  }
}
